import React from 'react';
import { TbUserQuestion, TbUserShield } from 'react-icons/tb';
import ButtonClose from '../Form/ButtonClose';
import { useTranslation } from 'react-i18next';
import { useCartContext } from '../../Contexts/CartContext';
import FormLogin from '../Form/FormLogin';
import ButtonLoginSSO from './ButtonLoginSSO';
import FormLoginBasic from '../Form/FormLoginBasic';
import { useLoginContext } from '../../Contexts/LoginContext';
import ButtonQuickPurchase from '../Form/ButtonQuickPurchase';
import { useLayoutContext } from '../../Contexts/LayoutContext';

interface LoginBasicProps {
    onClose: CallableFunction;
}

const Login = ({ onClose }: LoginBasicProps) => {
    const { t } = useTranslation();
    const { setReturnToCheckout } = useCartContext();
    const { isQuickPurchase, isAuthenticatedBySSO, setIsQuickPurchase } = useLoginContext();
    const { company } = useLayoutContext();

    const handleClose = () => {
        localStorage.removeItem('redirect');
        setReturnToCheckout(false);
        setIsQuickPurchase(false);
        onClose();
    };

    const renderContent = () => {
        if (isQuickPurchase) {
            return <FormLoginBasic onCancel={handleClose} />;
        }

        if (isAuthenticatedBySSO && company?.sso_active) {
            return (
                <div className='grid p-2 pt-4 gap-3 rounded-xl'>
                    <ButtonLoginSSO />
                    <ButtonQuickPurchase className='text-nowrap' />
                </div>
            );
        }

        return <FormLogin onCancel={handleClose} />;
    };

    return (
        <div className="relative grid p-4">
            <ButtonClose onClick={handleClose} fixedOnTop />

            <div className='flex flex-row w-full items-center gap-2 p-3 py-4'>
                <span>
                    {isQuickPurchase 
                        ? <TbUserQuestion size={45} className='-ms-2 animate-fade-in' />
                        : <TbUserShield size={45} className='-ms-2 animate-fade-in' />
                    }
                </span>

                <div className='grid text-left gap-0.5'>
                    <h2 className={`text-2xl font-extrabold leading-none ${isQuickPurchase ? 'text-custom-primary' : ''}`}>
                        {isQuickPurchase
                            ? t('login.basic.title')
                            : t('login.title')}
                    </h2>

                    <p className='text-gray-500 leading-none'>
                        {isQuickPurchase
                            ? t('login.basic.subtitle')
                            : t('login.subtitle')}
                    </p>
                </div>
            </div>

            {renderContent()}
        </div>
    );
};

export default Login;